import { useFormik } from 'formik';
import AuthWrapper from 'shared/components/auth_wrapper/AuthWrapper';
import { OtpVS } from 'shared/utils/validation/AuthValidation';
import CustomButton from 'shared/components/common/custom_button/CustomButton';
import CustomInput from 'shared/components/common/custom_input/CustomInput';
import styles from './style.module.scss';
import { classNames } from 'shared/utils/Helper';
import Heading from 'shared/components/common/heading/Heading';
import { forgotImage, BackIcon } from 'assets';
import { useNavigate } from 'react-router-dom';
import { routeConstant } from 'shared/routes/RouteConstant';

const Otp = () => {
    const navigate = useNavigate();
    const initialValues = {
        otp: ''
    };
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: initialValues,
        validationSchema: OtpVS,
        onSubmit: (value) => {
            otpHandler(value);
        }
    });
    const { handleChange, handleSubmit, values, touched, errors } = formik;

    const otpHandler = (values, action) => {
        navigate(routeConstant.resetPassword.path);
    };
    const handleNavigate = () => {
        navigate(routeConstant.login.path);
    };

    return (
        <AuthWrapper mainImage={forgotImage} heading="“ Use Wise Tech to manage and collaborate in a smoother and more efficient way. ”">
            <div className={classNames(styles.OtpContainer)}>
                <Heading heading="Enter OTP" headingStyle={classNames(styles.OtpHeading)} />
                <div className={classNames(styles.OtpMainTitle)}>A 4 digit code has been sent to your email</div>
                <CustomInput label="OTP" placeholder="4153" value={values.otp} onChange={handleChange('otp')} error={errors.otp && touched.otp ? errors.otp : ''} />

                <CustomButton text="Verify OTP" containerStyle={styles.ButtonContainer} submitHandle={handleSubmit} />
                <CustomButton Icon={BackIcon} text="Back to Login" containerStyle={styles.BackButton} IconStyle={styles.Icon} submitHandle={handleNavigate} />
            </div>
        </AuthWrapper>
    );
};

export default Otp;
